import { Component, OnInit } from '@angular/core';
import { HomeClockComponent } from '../home-clock/home-clock.component';
import { GeneralStatusComponent } from '../general-status/general-status.component';
import { MapGoogleComponent } from '../map-google/map-google.component';
import { AlarmsHistoryChartComponent } from '../alarms-history-chart/alarms-history-chart.component';
import { CurrentInfoComponent } from '../current-info/current-info.component';
import { OsInfoComponent } from '../os-info/os-info.component';
import { ControllerSocketService } from '../../services/sockets/backend-controller/controller.service';
import { AlarmsService } from '../../dashboard/alarms/alarms.service';
import { Installation } from '../../dashboard/alarms/alarm.model';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [
    HomeClockComponent,
    GeneralStatusComponent,
    MapGoogleComponent,
    AlarmsHistoryChartComponent,
    CurrentInfoComponent,
    OsInfoComponent,
  ],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
})
export class HomeComponent implements OnInit {
  installationIds?: string;

  constructor(
    private socket: ControllerSocketService,
    private alarmsService: AlarmsService
  ) {}
  ngOnInit(): void {
    this.alarmsService.getInstallations().subscribe((res) => {
      const installations = res.data
        .filter((installation: Installation) => installation.active === true)
        .map((installation: Installation) => installation.id);

      this.installationIds = installations.join(',');
    });
  }
  desconectar() {
    this.socket.emitEvent('manualDisconnect', null);
  }
}
